import type { Sort } from '@/stores/sorting.ts';
import type { ConfigRequest, ConfigResponse } from '@/types';
import { sortToQuery } from '@/utils/misc.ts';
import type { AxiosInstance, AxiosResponse } from 'axios';

class ConfigService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    getPath(id?: string) {
        return id ? `/api/configs/${id}` : '/api/configs';
    }

    index(page: number, filter?: object, sort: null | Sort = null, perPage?: number) {
        return this.apiService.get(this.getPath(), {
            params: { page: page, per_page: perPage, ...filter, ...sortToQuery(sort) },
        });
    }

    show(id: string) {
        return this.apiService.get(this.getPath(id));
    }

    store(request: ConfigRequest) {
        return this.apiService.post(this.getPath(), request);
    }

    update(id: string, request: ConfigRequest): Promise<AxiosResponse<ConfigResponse>> {
        return this.apiService.put(this.getPath(id), request);
    }

    deactivate(id: string): Promise<AxiosResponse<ConfigResponse>> {
        return this.apiService.put(this.getPath(id), {
            inactive_at: new Date().toISOString(),
        });
    }

    reactivate(id: string): Promise<AxiosResponse<ConfigResponse>> {
        return this.apiService.put(this.getPath(id), {
            inactive_at: null,
        });
    }
}

export default ConfigService;
